import React from 'react';
import { BarChart3, Globe, Rocket } from 'lucide-react';
import { useData } from '../context/DataContext';
import { useAuth, hasModule } from '../context/AuthContext';
import { useModule } from '../App';

const Sidebar = ({ mobileOpen }) => {
  const { user } = useAuth();
  const { lobs, currentLobId, setCurrentLobId } = useData();
  const { currentModule, setCurrentModule } = useModule();
  const visibleLobs = lobs.filter((l) => l.is_active !== false);

  return (
    <div className={`crm-sidebar${mobileOpen ? ' mobile-open' : ''}`} data-testid="sidebar">
      <div className="lob-switcher">
        {visibleLobs.length === 0 && (
          <div style={{ padding: 12, fontSize: 11, color: 'var(--text-faded)' }} data-testid="sidebar-no-lobs">
            No business lines available.
          </div>
        )}
        {visibleLobs.map((l, i) => (
          <React.Fragment key={l.id}>
            {i > 0 && <div className="lob-divider" />}
            <div className={`lob-tab${currentLobId === l.id ? ' active' : ''}`} onClick={() => setCurrentLobId(l.id)} data-testid={`lob-tab-${l.key}`}>
              <div className="lob-icon" style={{ background: l.accent_bg }}>
                <span style={{ fontSize: 14 }}>{l.icon || '💼'}</span>
              </div>
              <div>
                <div className="lob-name">{l.label}</div>
                <div className="lob-count-txt">{l.key.toUpperCase()}</div>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>

      <div className="sb-nav">
        {(hasModule(user, 'reports') || hasModule(user, 'website') || hasModule(user, 'funnels')) && (
          <>
            <div className="sb-section-hd">Modules</div>
            {hasModule(user, 'reports') && (
              <div className={`sb-item${currentModule === 'reports' ? ' active' : ''}`} onClick={() => setCurrentModule('reports')} data-testid="sidebar-reports-link">
                <BarChart3 size={12} />Reports
              </div>
            )}
            {hasModule(user, 'website') && (
              <div className={`sb-item${currentModule === 'website' ? ' active' : ''}`} onClick={() => setCurrentModule('website')} data-testid="sidebar-website-link">
                <Globe size={12} />Website
              </div>
            )}
            {hasModule(user, 'funnels') && (
              <div className={`sb-item${currentModule === 'funnels' ? ' active' : ''}`} onClick={() => setCurrentModule('funnels')} data-testid="sidebar-funnels-link">
                <Rocket size={12} />Funnels
              </div>
            )}
            <div className="sb-sep" />
          </>
        )}
        <div className="sb-section-hd">Quick filters</div>
        {['Active', 'Overdue', 'Won this month'].map((label) => (
          <div className="sb-item" key={label} data-testid={`sidebar-quickfilter-${label.toLowerCase().replace(/\s+/g,'-')}`}>{label}</div>
        ))}
        <div className="sb-sep" />
        <div className="sb-section-hd">Account</div>
        <div className="sb-item" data-testid="sidebar-user-name">
          {user?.name || user?.email}
          <span className="sb-count">{user?.role === 'super_admin' ? 'Admin' : 'Staff'}</span>
        </div>
        {user?.role === 'super_admin' && (
          <div className={`sb-item${currentModule === 'settings' ? ' active' : ''}`} onClick={() => setCurrentModule('settings')} data-testid="sidebar-settings-link">⚙ Settings</div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
